import { call, put, StrictEffect, takeLatest } from 'redux-saga/effects';
import fetchAPI from '@utils/fetchAPI';
import DomainByEnv from '@utils/domainByEnv';
import * as actionTypes from '../actionTypes';
import * as actions from '../actions';

declare const window: any;

const detailRoute = `${DomainByEnv()}/detail`;

function* setItinerariesAsync(
    action: actions.I_ItinerariesAction
): Generator<StrictEffect, any, any> {
    const itineraries = yield call(fetchAPI, {
        url: `${detailRoute}/daytripinfojson`,
        req: action.payload,
    });
    // 在載入行程或更換行程取得新資料後呼叫後端放的 /scripts/detail/reactproductdetail.js 裡的seo相關funtion
    const seoPara = document.getElementById('seoPara');
    if (itineraries.TDHDesc !== '' && itineraries.TDHDesc !== null) {
        seoPara?.setAttribute('data-tdhdesc', itineraries.TDHDesc);
    } else {
        const description = document
            .querySelector("[name='description']")!
            .attributes.getNamedItem('content')!.textContent;
        seoPara?.setAttribute('data-tdhdesc', description || '');
    }
    window.writeSEOData();

    yield put(actions.setItinerariesSUCCESS(itineraries));
}

export function* watchSetItinerariesAsync() {
    yield takeLatest(actionTypes.SET_ITINERARIES, setItinerariesAsync);
}

function* setOptionalInfoAsync(
    action: actions.I_OptionalInfoAction
): Generator<StrictEffect, any, any> {
    const data = yield call(fetchAPI, {
        url: `${detailRoute}/optionalinfojson`,
        req: action.payload,
    });
    yield put(actions.setOptionalInfoSUCCESS(data));
}

export function* watchsetOptionalInfoAsync() {
    yield takeLatest(actionTypes.SET_OPTIONALINFO, setOptionalInfoAsync);
}

function* setNoticeInfoAsync(
    action: actions.I_NoticeinfoAction
): Generator<StrictEffect, any, any> {
    const data = yield call(fetchAPI, {
        url: `${detailRoute}/noticeinfojson`,
        req: action.payload,
    });
    yield put(actions.setsetNoticeinfoSUCCESS(data));
}

export function* watchsetNoticeInfoAsync() {
    yield takeLatest(actionTypes.SET_NOTICEINFO, setNoticeInfoAsync);
}

function* setPoiAsync(action: actions.I_PoiAction): Generator<StrictEffect, any, any> {
    const loadingData = {
        DayID: null,
        POIID: null,
        Name: null,
        ImgList: null,
        ImgMList: null,
        Introduction: null,
        Longtitude: null,
        Latitude: null,
        Address: null,
        PhoneList: [],
        WebUrl: null,
        Grade: [],
        CheckIn: null,
        CheckOut: null,
    };
    yield put(actions.setPoiSUCCESS(loadingData));
    const data = yield call(fetchAPI, {
        url: `${detailRoute}/poiinfojson`,
        req: action.payload,
    });
    yield put(actions.setPoiSUCCESS(data));
}

export function* watchPoiAsync() {
    yield takeLatest(actionTypes.SET_POI, setPoiAsync);
}

export default [
    watchSetItinerariesAsync(),
    watchsetOptionalInfoAsync(),
    watchsetNoticeInfoAsync(),
    watchPoiAsync(),
];
